export const listOfSections = {
    guardianName: "guardianName",
    guardianDetails: {
        guardianContactNumber: "guardianContactNumber",
        guardianCountryCode: "guardianCountryCode",
    },
    bloodGroup: "bloodGroup",
    underGraduateDegree: "underGraduateDegree",
    underGraduateInstitute: {
        underGraduateInstituteName: "underGraduateInstituteName",
        underGraduateInstituteAddress: "underGraduateInstituteAddress"
    },
    registrationNumber: "registrationNumber",
    passingYear: "passingYear",
    aadharCard: "aadharCard",
    panCard: "panCard",
    otherDocs: "otherDocs",
    signature: {
        signature: "signature",
        placeOfSignature: "placeOfSignature",
        dateOfSignature: "dateOfSignature",
        bssAcknowledged: "bssAcknowledged"
    },
} as const